"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@archive-export/success",
  ERROR: "@@archive-export/error",
  EXPORT_RESET: "@@archive-export/export-reset",
  FINDS_ARCHIVE_LIST_BASED_SEARCH_PARAMS: "@@archive-export/find-archive-list-based-on-search-params",
  DELETE_ARCHIVE_BY_ARCHIVE_ID: "@@archive-export/delete-archive-list-basedd-on-archive-id"
};
exports.actionTypes = actionTypes;